<div class="container mt-5">
  <div class="row justify-content-center">
    <div >
      <div class="card text-center">
        <div class="card-header">
          <h2>Плащането беше успешно!</h2>
        </div>
        <div class="card-body">
          <p class="card-text">Вашето плащане беше успешно обработено.</p>
          <p class="card-text">Ще отнеме няколко часа, за да бъде отразено при нас.</p> 
        </div>
        <div class="card-footer text-muted">
         От Екипа на ЕГише, Благодарим ви, че използвате нашите услуги!
        </div>
      </div>
    </div>
  </div>
</div>
